import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { AiChipShell, GetAiFilterChipTID } from './AiChipShell';
import { MinMaxFields } from './MinMaxFields';
export const MinMaxChip = (param)=>{
    let { testId, fieldLabel, value, valueLabel, valuePrefix, tone, validate, onApply, onRemove, biPrefix, autoOpen = false, texts } = param;
    const testIds = useMemo(()=>GetAiFilterChipTID(testId), [
        testId
    ]);
    const [draft, setDraft] = useState(value);
    const [error, setError] = useState(null);
    const resetDraft = ()=>{
        setDraft(value);
        setError(null);
    };
    const changeDraft = (next)=>{
        setDraft(next);
        setError(null);
    };
    const applied = ()=>{
        const trimmed = {
            min: draft.min.trim(),
            max: draft.max.trim()
        };
        if (validate != null && !validate(trimmed)) {
            var _texts_validationError;
            setError((_texts_validationError = texts.validationError) !== null && _texts_validationError !== void 0 ? _texts_validationError : '');
            return false;
        }
        onApply(trimmed);
        return true;
    };
    const fieldsProps = {
        testIds,
        biPrefix,
        draft,
        minPlaceholder: texts.minPlaceholder,
        maxPlaceholder: texts.maxPlaceholder,
        error,
        onChange: changeDraft
    };
    return /*#__PURE__*/ _jsx(AiChipShell, {
        testId: testId,
        fieldLabel: fieldLabel,
        biPrefix: biPrefix,
        autoOpen: autoOpen,
        valuePrefix: valuePrefix,
        valueLabel: valueLabel,
        tone: tone,
        applyText: texts.apply,
        onOpen: resetDraft,
        onApply: applied,
        onRemove: onRemove,
        children: (param)=>{
            let { apply } = param;
            return /*#__PURE__*/ _jsx(MinMaxFields, _object_spread_props(_object_spread({}, fieldsProps), {
                onSubmit: apply
            }));
        }
    });
};
